import { PRODUCT } from "../configs/constants/ProductConstant";
import { getProductsVacation } from "../services/ProductService";

export const GetProductVacationDetailAction = (params) => {
  return {
    type: PRODUCT.GET_PRODUCT_VACATION,
    payload: getProductsVacation(params),
  };
};
